// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1dRiF{margin-bottom:2rem}@media(max-width:767px){._1dRiF{margin-left:-1rem;margin-right:-1rem}}._1ZHYP{width:40px;width:2.5rem;height:40px;height:2.5rem;margin-right:1rem}._2n4xv{margin-bottom:1rem}._3L1O4{display:-ms-flexbox;display:flex;background-color:#fff;padding:1.5rem;border-radius:.25rem}._3L1O4:not(:last-child){margin-bottom:1rem}@media(max-width:767px){._3L1O4:not(:last-child){margin-bottom:.25rem}}._20jte{color:#595757;margin-bottom:.5rem}._8VxQp{white-space:pre-line}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"list": "_1dRiF",
	"icon": "_1ZHYP",
	"title": "_2n4xv",
	"listItem": "_3L1O4",
	"itemTitle": "_20jte",
	"description": "_8VxQp"
};
module.exports = exports;
